export function getLastSubscription(subscriptions = []) {
	(subscriptions || []).sort((subsc1 , subsc2) => subsc2.subscriptionDate - subsc1.subscriptionDate )
	return subscriptions[0] || {};
}



// WEBPACK FOOTER //
// ./src/opencell/pages/utils/SubscriptionUtils.js